module.exports = __webpack_public_path__ + "static/img/loading_upload.57b97025.gif";